import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { UsersListRequest } from 'types/users/users';
import { initialListData } from 'pages/users/index';
import { useUserStatusQuery, useUserSystemQuery } from 'store/slices/user/user';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    setDataUsersRequestList?: React.Dispatch<
        React.SetStateAction<UsersListRequest>
    >;
}

const FilterUsers: React.FC<Props> = (props: Props) => {
    const { setDataUsersRequestList } = props;
    const { handleSubmit, control, reset } = useForm<UsersListRequest>({
        defaultValues: {
            nickName: undefined,
            minCard: undefined,
            maxCard: undefined,
            system: undefined,
            status: undefined,
        },
    });

    const { data: statusType } = useUserStatusQuery();
    const { data: systemType } = useUserSystemQuery();

    const onSubmit = (values: UsersListRequest) => {
        if (setDataUsersRequestList) {
            setDataUsersRequestList((prevState) => ({
                ...prevState,
                nickName: values.nickName,
                minCard: values.minCard,
                maxCard: values.maxCard,
                system: values.system,
                status: values.status,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataUsersRequestList) {
            setDataUsersRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="nickName"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'User Name'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '20%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <Controller
                    name="minCard"
                    control={control}
                    render={({
                        field: { name, value = undefined, onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Min Card'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '10%', ml: pxToRem(10) }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <Controller
                    name="maxCard"
                    control={control}
                    render={({
                        field: { name, value = undefined, onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Max Card'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '10%', ml: pxToRem(10) }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '20%' }}>
                    <InputLabel>System Type</InputLabel>
                    <Controller
                        name="system"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="System Type"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="System Type"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {systemType?.map((status, index) => (
                                    <MenuItem value={status} key={index}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '20%' }}>
                    <InputLabel>Status Type</InputLabel>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Status Type"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Status Type"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {statusType?.map((status, index) => (
                                    <MenuItem value={status} key={index}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterUsers;
